import { render, staticRenderFns } from "./WorkflowReviewRecord.vue?vue&type=template&id=21271436"
import script from "./WorkflowReviewRecord.vue?vue&type=script&lang=js"
export * from "./WorkflowReviewRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports